import { useEffect, useRef } from 'react';
import { Cropper, type CropperRef, type DefaultTransforms } from 'react-advanced-cropper';
import { useImage } from '@/store/image';
import 'react-advanced-cropper/dist/style.css';

/**
 * REF:= https://advanced-cropper.github.io/react-advanced-cropper/
 */
export interface ImageCropperProps {
  imageSrc: string;
  defaultTransforms?: DefaultTransforms;
}

export const ImageCropper: React.FC<ImageCropperProps> = ({ imageSrc, defaultTransforms }) => {
  const cropperRef = useRef<CropperRef>(null);
  const setControls = useImage.use.setControls();

  useEffect(() => {
    if (cropperRef.current) {
      setControls(cropperRef.current);
    }
  }, [cropperRef.current]);

  return (
    <div className='relative w-full h-full'>
      <Cropper
        defaultTransforms={defaultTransforms}
        ref={cropperRef}
        // imageRestriction={ImageRestriction.fillArea}
        src={imageSrc}
        // wrapperComponent={CustomWrapper}
        backgroundWrapperProps={{}}
        stencilProps={
          {
            // aspectRatio: 4 / 3,
            // movable: true,
            // resizable: false,
            // grid: true,
            // lines: true,
          }
        }
        // backgroundWrapperProps={{
        //   scaleImage: true,
        //   moveImage: true,
        // }}
        style={{
          backgroundColor: 'lightgray',
        }}
      />
      {/* <div className='absolute bottom-3 right-3 px-4 gap-2 flex flex-col items-start w-auto'>
        <Button size='sm' color='warning' onPress={handleApply}>
          Apply Crop
        </Button>
      </div> */}
    </div>
  );
};

export default ImageCropper;
